<script setup lang="ts">
defineProps({
  categories: null,
  searchable: { type: Boolean }
})
const selected = defineModel<number>()
</script>

<template>
  <div class="items-ul">
    <div v-if="searchable" mb-10px w-243px class="item !lg:hidden">
      <svg shrink-0 xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
        <path d="M11.5 21C16.7467 21 21 16.7467 21 11.5C21 6.25329 16.7467 2 11.5 2C6.25329 2 2 6.25329 2 11.5C2 16.7467 6.25329 21 11.5 21Z" stroke="#7C7C7C" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
        <path d="M22 22L20 20" stroke="#7C7C7C" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
      </svg>

      <InputText w-100px flex-grow placeholder="Search by token..." />
    </div>

    <ul overflow-x-auto>
      <li v-for="category, idx in categories" :key="idx" :class="[idx === selected && 'selected']" @click="selected = idx">
        <img v-if="category.icon" :src="category.icon" alt="">
        <span>{{ category.title }}</span>
      </li>

      <li v-if="searchable" class="!lt-lg:hidden">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
          <path d="M11.5 21C16.7467 21 21 16.7467 21 11.5C21 6.25329 16.7467 2 11.5 2C6.25329 2 2 6.25329 2 11.5C2 16.7467 6.25329 21 11.5 21Z" stroke="#7C7C7C" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
          <path d="M22 22L20 20" stroke="#7C7C7C" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
        </svg>

        <InputText placeholder="Search by token..." />
      </li>
    </ul>
  </div>
</template>

<style scoped lang="scss">
.items-ul {
  ul {
    @apply row;
  }

  li,
  .item {
    flex-shrink: 0;
    border-radius: 32px;
    display: flex;
    padding: 10px 16px;
    justify-content: center;
    align-items: center;
    align-self: stretch;
    cursor: pointer;
    user-select: none;
    border: 1px solid #7c7c7c;
    color: #7c7c7c;

    @apply lt-lg:p-[6.75px_10.8px];

    &.selected {
      background: rgba(104, 92, 240, 0.1);
      color: white;
      border: 1px solid #fff;
    }

    img,
    svg {
      @apply lt-lg:size-16.2px mr-8px;
    }
    span {
      @apply text-9.45px lg:text-14px font-500 lh-160%;
    }

    &:not(:first-child) {
      @apply ml-16px;
    }

    :deep(.p-inputtext) {
      background: transparent;
      @apply ml-8px outline-none;
    }
  }
}
</style>
